const kExtensorAuthHandling = Symbol("extensorIoAuthHandling");
const kSocketAuthStatus = Symbol("extensorSocketAuthStatus");
const kSocketAuthTimeout = Symbol("extensorSocketAuthTimeout");

export { kExtensorAuthHandling, kSocketAuthStatus, kSocketAuthTimeout };
